import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { migrateStorage } from './utils/storage';
import { initAnalytics } from './utils/analytics';

// Oude gegevens eerst omzetten, zodat de app meteen met de huidige vorm werkt.
migrateStorage();

// Vang het install-event vroeg op, ook als React nog niet gemount is.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPWAEvent = e as never;
});

// Eenmalig de cache van de oude handgeschreven service worker opruimen.
if ('caches' in window) {
  caches
    .keys()
    .then((names) => names.filter((n) => n.startsWith('darts-counter-')).forEach((n) => caches.delete(n)))
    .catch(() => {});
}

// Laadt Google Analytics alleen als de bezoeker eerder toestemming gaf.
initAnalytics();

// De service worker wordt door vite-plugin-pwa geregistreerd (zie useAppUpdate).
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
